import type { Address, ReservationMode } from '@iheartjane/types';
import { useMutation } from '@tanstack/react-query';
import { stringify } from 'qs';

import { getJwt } from '@jane/shared/auth';
// eslint-disable-next-line no-restricted-imports
import type { Cart } from '@jane/shared/models';

import { janeApi } from '../api/janeApi';
import { urls } from './promoCode.util';

interface ValidatePromoCodeProps {
  deliveryAddress?: Address | null;
  promoCode: string;
  reservationMode: ReservationMode;
  userGroupSpecialId?: number | string;
  uuid: string;
}

type ValidatePromoCodeResponse =
  { cart: Cart; isValid: true } | { isValid: false };

const validatePromoCode = async ({
  deliveryAddress,
  promoCode: promo_code,
  reservationMode: reservation_mode,
  userGroupSpecialId: user_group_special_id,
  uuid,
}: ValidatePromoCodeProps): Promise<ValidatePromoCodeResponse> => {
  const queryString = `?${stringify({
    delivery_address: deliveryAddress || undefined,
    promo_code,
    reservation_mode,
    user_group_special_id,
    uuid,
  })}`;

  try {
    const response = await janeApi.get<{
      cart: Cart;
      validations?: Record<string, string>;
    }>(`${urls.promoCode}${queryString}`, getJwt());

    if (response.validations) {
      return { isValid: false };
    }

    return { isValid: true, cart: response.cart };
  } catch {
    return { isValid: false };
  }
};

export const useValidatePromoCode = ({
  onSuccess,
}: { onSuccess?: (data: ValidatePromoCodeResponse) => void } = {}) =>
  useMutation({
    mutationFn: validatePromoCode,
    onSuccess,
  });
